import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { UmbracoService } from './umbraco.service';

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  private _faqData = new Subject<any[]>();
  public faqData: Observable<any[]> = this._faqData.asObservable();

  private _faqQuestions = new Subject<any[]>();
  public faqQuestions: Observable<any[]> = this._faqQuestions.asObservable();

  constructor(
      private umbracoService: UmbracoService) {
  }

  readFAQData() {
      this.umbracoService.postUmbracoData('fAQList', ['text'], '/content/getcontent')
      .subscribe(
          (response: any[]) => {
              this._faqData.next(response);
          },
          (err: HttpErrorResponse) => {
              console.log(err);
          }
      );
  }

  readFAQQuestions() {
    this.umbracoService.postUmbracoData('fAQItem', ['question', 'answer'], '/content/getcontent')
    .subscribe(
        (response: any[]) => {
            this._faqQuestions.next(response);
        },
        (err: HttpErrorResponse) => {
            console.log(err);
        }
    );
}



}
